const global = window;

// Rafraîchissement générique de cibles ajax
global.refreshTargets = function (refreshConfig, contextElement) {
    if (!refreshConfig) return;
    let targets = refreshConfig;
    if (typeof targets === 'string') {
        try {
            targets = JSON.parse(targets);
        } catch (e) {
            targets = [targets];
        }
    }
    if (!Array.isArray(targets)) {
        targets = [targets];
    }

    const pf = contextElement ? $(contextElement).closest('.window, body') : $('body');
    targets.forEach((targetName) => {
        let $target = pf.find('#' + targetName + ', [data-name="' + targetName + '"]').filter('.ajaxable');
        if (!$target.length) {
            $target = $('#' + targetName + ', [data-name="' + targetName + '"]').filter('.ajaxable');
        }
        if (!$target.length) {
            $target = pf.find('#' + targetName + ', [data-name="' + targetName + '"]');
        }
        if (!$target.length) {
            $target = $('#' + targetName + ', [data-name="' + targetName + '"]');
        }
        if ($target.length && $target.data('data') && typeof $target.data('data').reload === 'function') {
            $target.data('data').reload();
        }
    });
};

// Delegated click handler pour les éléments [data-refresh] qui ne sont ni toggle ni popup
$(document).on('click', '[data-refresh]', function (event) {
    const $el = $(this);
    if ($el.is(':disabled') || $el.hasClass('btn--disabled') || $el.data('hold')) {
        return;
    }
    // Si c'est un toggle ou popup, le rafraîchissement est géré par leur callback de succès
    if ($el.data('toggle') || $el.attr('data-toggle') || $el.data('popup') || $el.attr('data-popup') || $el.data('query')) {
        return;
    }
    const refreshData = $el.data('refresh');
    if (refreshData) {
        global.refreshTargets(refreshData, this);
    }
});

if (typeof inputs !== 'undefined' && inputs.behavior) {
    inputs.behavior.refresh = function (data, name, niceName, type, input, inputParent, inputWindow) {
        if (data.refresh) {
            input.data('refresh', data.refresh);
            if (!data.toggle && !data.popup && !data.query) {
                input.on('click', function () {
                    global.refreshTargets(data.refresh, this);
                });
            }
        }
        return data;
    };
}
